export default __webpack_public_path__ + "static/media/Rexel - Logo.97a603cb.png";